<router-outlet></router-outlet>
<joy-toast></joy-toast>